









































import { Component, Vue } from 'vue-property-decorator';
import { AgencyModule } from '@/store/modules/agency';
import { ComplianceModule } from '@/store/modules/compliance';
import Alert from '@/components/Shared/Alert.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import ComplianceDocuments from '@/components/Documents/ComplianceDocuments.vue';
import IRootState from '@/store/index';


@Component({
	name: 'AgencyCompliance',
  	components: { Alert, ComplianceDocuments }
})
export default class extends GiganautVue {

  	get loading() {
		return ComplianceModule.loading;
  	}
}
